import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withMultiFileUploader } from '../../../app/hoc/withMultiFileUploader';
import { LOADER_CLOSE, LOADER_OPEN } from '../../../app/redux/actions';
import { apiHost, baseUrl } from '../../../app/api/config';
import { FILE_UPLOADED } from '../../../app/redux/actions/tutors';

const ImagesUploader = ({
  format,
  loaderOpen,
  loaderClose,
  onFileLoad,
  images,
  courseCreation,
  onFileUpload,
}) => {
  useEffect(() => {
    if (courseCreation?.loading === 2) {
      uploadFiles({
        id: courseCreation?.courseId,
        keys: Object.keys(images),
        files: images,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [courseCreation, images]);

  const uploadFiles = ({ id, files, keys }) => {
    if (!files || Object.values(files)?.length <= 0) {
      onFileUpload();
      return;
    }
    loaderOpen();
    const filesToUpload = files;
    const fileToRead = Object.values(files)[0];
    const reader = new FileReader();

    reader.onabort = (evt) => {
      // eslint-disable-next-line no-console
      console.log('FileUpload > reader.onabort', evt);
    };
    reader.onerror = (err) => {
      // eslint-disable-next-line no-console
      console.log('FileUpload > reader.onerror', err);
    };
    reader.onload = (e) => {
      onFileLoad(
        keys,
        filesToUpload,
        `${apiHost}${baseUrl}pzzl_course/course/${id}/images/upload`,
        onFileUpload,
        () => loaderClose(),
        () => onFileUpload('images') // onError
      );
    };
    if (!filesToUpload) loaderClose();
    switch (format) {
      case 'BASE64':
        reader.readAsDataURL(fileToRead);
        break;

      case 'BINARY':
      default:
        reader.readAsArrayBuffer(fileToRead);
        break;
    }
  };

  return <div style={{ display: 'none' }}>ImagesUploader</div>;
};

ImagesUploader.propTypes = {
  images: PropTypes.object,
  courseCreation: PropTypes.object,
  onFileUpload: PropTypes.func,

  // HOC: fileUploader
  format: PropTypes.string,
  loaderOpen: PropTypes.func,
  loaderClose: PropTypes.func,
  onFileLoad: PropTypes.func,
};

export default connect(
  (state) => {
    const { courseCreation } = state.tutors;
    return { courseCreation };
  },
  (dispatch) => ({
    loaderOpen: () => dispatch({ type: LOADER_OPEN }),
    loaderClose: () => dispatch({ type: LOADER_CLOSE }),
    onFileUpload: (error) =>
      dispatch({ type: FILE_UPLOADED, loading: 1, error }),
  })
)(withMultiFileUploader(ImagesUploader));
